"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Avatar = /*#__PURE__*/function (_Component) {
  function Avatar(props) {
    var _this;
    _classCallCheck(this, Avatar);
    _this = _callSuper(this, Avatar, [props]);
    _this.avatarRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      display: false,
      size: _this.setSize()
    };
    _this.get_avatar = _this.get_avatar.bind(_this);
    _this.badImage = _this.badImage.bind(_this);
    _this.validateAvatarImg = _this.validateAvatarImg.bind(_this);
    _this.setSize = _this.setSize.bind(_this);
    return _this;
  }
  _inherits(Avatar, _Component);
  return _createClass(Avatar, [{
    key: "badImage",
    value: function badImage() {
      this.setState({
        display: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.forceText) {
        this.validateAvatarImg();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.email !== prevProps.email && !this.props.forceText) {
        this.validateAvatarImg(this.props);
      }
    }
  }, {
    key: "validateAvatarImg",
    value: function validateAvatarImg(nextProps) {
      var _this2 = this;
      var img = new Image();
      img.onerror = this.badImage;
      img.onload = function () {
        _this2.setState({
          display: true
        });
      };
      img.src = this.get_avatar(nextProps);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.display === nextState.display && this.props.email === nextProps.email) {
        return false;
      }
      return true;
    }
  }, {
    key: "get_avatar",
    value: function get_avatar(nextProps) {
      var email = nextProps === undefined ? this.props.email : nextProps.email;
      var MD5 = function MD5(s) {
        function L(k, d) {
          return k << d | k >>> 32 - d;
        }
        function K(G, k) {
          var I, d, F, H, x;
          F = G & 2147483648;
          H = k & 2147483648;
          I = G & 1073741824;
          d = k & 1073741824;
          x = (G & 1073741823) + (k & 1073741823);
          if (I & d) {
            return x ^ 2147483648 ^ F ^ H;
          }
          if (I | d) {
            if (x & 1073741824) {
              return x ^ 3221225472 ^ F ^ H;
            } else {
              return x ^ 1073741824 ^ F ^ H;
            }
          } else {
            return x ^ F ^ H;
          }
        }
        function r(d, F, k) {
          return d & F | ~d & k;
        }
        function q(d, F, k) {
          return d & k | F & ~k;
        }
        function p(d, F, k) {
          return d ^ F ^ k;
        }
        function n(d, F, k) {
          return F ^ (d | ~k);
        }
        function u(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(r(F, aa, Z), k), I));
          return K(L(G, H), F);
        }
        function f(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(q(F, aa, Z), k), I));
          return K(L(G, H), F);
        }
        function D(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(p(F, aa, Z), k), I));
          return K(L(G, H), F);
        }
        function t(G, F, aa, Z, k, H, I) {
          G = K(G, K(K(n(F, aa, Z), k), I));
          return K(L(G, H), F);
        }
        function e(G) {
          var Z;
          var F = G.length;
          var x = F + 8;
          var k = (x - x % 64) / 64;
          var I = (k + 1) * 16;
          var aa = Array(I - 1);
          var d = 0;
          var H = 0;
          while (H < F) {
            Z = (H - H % 4) / 4;
            d = H % 4 * 8;
            aa[Z] = aa[Z] | G.charCodeAt(H) << d;
            H++;
          }
          Z = (H - H % 4) / 4;
          d = H % 4 * 8;
          aa[Z] = aa[Z] | 128 << d;
          aa[I - 2] = F << 3;
          aa[I - 1] = F >>> 29;
          return aa;
        }
        function B(x) {
          var k = "",
            F = "",
            G,
            d;
          for (d = 0; d <= 3; d++) {
            G = x >>> d * 8 & 255;
            F = "0" + G.toString(16);
            k = k + F.substr(F.length - 2, 2);
          }
          return k;
        }
        function J(k) {
          k = k.replace(/rn/g, "n");
          var d = "";
          for (var F = 0; F < k.length; F++) {
            var x = k.charCodeAt(F);
            if (x < 128) {
              d += String.fromCharCode(x);
            } else {
              if (x > 127 && x < 2048) {
                d += String.fromCharCode(x >> 6 | 192);
                d += String.fromCharCode(x & 63 | 128);
              } else {
                d += String.fromCharCode(x >> 12 | 224);
                d += String.fromCharCode(x >> 6 & 63 | 128);
                d += String.fromCharCode(x & 63 | 128);
              }
            }
          }
          return d;
        }
        var C = Array();
        var P, h, E, v, g, Y, X, W, V;
        var S = 7,
          Q = 12,
          N = 17,
          M = 22;
        var A = 5,
          z = 9,
          y = 14,
          w = 20;
        var o = 4,
          m = 11,
          l = 16,
          j = 23;
        var U = 6,
          T = 10,
          R = 15,
          O = 21;
        s = J(s);
        C = e(s);
        Y = 1732584193;
        X = 4023233417;
        W = 2562383102;
        V = 271733878;
        for (P = 0; P < C.length; P += 16) {
          h = Y;
          E = X;
          v = W;
          g = V;
          Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
          V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
          W = u(W, V, Y, X, C[P + 2], N, 606105819);
          X = u(X, W, V, Y, C[P + 3], M, 3250441966);
          Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
          V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
          W = u(W, V, Y, X, C[P + 6], N, 2821735955);
          X = u(X, W, V, Y, C[P + 7], M, 4249261313);
          Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
          V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
          W = u(W, V, Y, X, C[P + 10], N, 4294925233);
          X = u(X, W, V, Y, C[P + 11], M, 2304563134);
          Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
          V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
          W = u(W, V, Y, X, C[P + 14], N, 2792965006);
          X = u(X, W, V, Y, C[P + 15], M, 1236535329);
          Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
          V = f(V, Y, X, W, C[P + 6], z, 3225465664);
          W = f(W, V, Y, X, C[P + 11], y, 643717713);
          X = f(X, W, V, Y, C[P + 0], w, 3921069994);
          Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
          V = f(V, Y, X, W, C[P + 10], z, 38016083);
          W = f(W, V, Y, X, C[P + 15], y, 3634488961);
          X = f(X, W, V, Y, C[P + 4], w, 3889429448);
          Y = f(Y, X, W, V, C[P + 9], A, 568446438);
          V = f(V, Y, X, W, C[P + 14], z, 3275163606);
          W = f(W, V, Y, X, C[P + 3], y, 4107603335);
          X = f(X, W, V, Y, C[P + 8], w, 1163531501);
          Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
          V = f(V, Y, X, W, C[P + 2], z, 4243563512);
          W = f(W, V, Y, X, C[P + 7], y, 1735328473);
          X = f(X, W, V, Y, C[P + 12], w, 2368359562);
          Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
          V = D(V, Y, X, W, C[P + 8], m, 2272392833);
          W = D(W, V, Y, X, C[P + 11], l, 1839030562);
          X = D(X, W, V, Y, C[P + 14], j, 4259657740);
          Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
          V = D(V, Y, X, W, C[P + 4], m, 1272893353);
          W = D(W, V, Y, X, C[P + 7], l, 4139469664);
          X = D(X, W, V, Y, C[P + 10], j, 3200236656);
          Y = D(Y, X, W, V, C[P + 13], o, 681279174);
          V = D(V, Y, X, W, C[P + 0], m, 3936430074);
          W = D(W, V, Y, X, C[P + 3], l, 3572445317);
          X = D(X, W, V, Y, C[P + 6], j, 76029189);
          Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
          V = D(V, Y, X, W, C[P + 12], m, 3873151461);
          W = D(W, V, Y, X, C[P + 15], l, 530742520);
          X = D(X, W, V, Y, C[P + 2], j, 3299628645);
          Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
          V = t(V, Y, X, W, C[P + 7], T, 1126891415);
          W = t(W, V, Y, X, C[P + 14], R, 2878612391);
          X = t(X, W, V, Y, C[P + 5], O, 4237533241);
          Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
          V = t(V, Y, X, W, C[P + 3], T, 2399980690);
          W = t(W, V, Y, X, C[P + 10], R, 4293915773);
          X = t(X, W, V, Y, C[P + 1], O, 2240044497);
          Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
          V = t(V, Y, X, W, C[P + 15], T, 4264355552);
          W = t(W, V, Y, X, C[P + 6], R, 2734768916);
          X = t(X, W, V, Y, C[P + 13], O, 1309151649);
          Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
          V = t(V, Y, X, W, C[P + 11], T, 3174756917);
          W = t(W, V, Y, X, C[P + 2], R, 718787259);
          X = t(X, W, V, Y, C[P + 9], O, 3951481745);
          Y = K(Y, h);
          X = K(X, E);
          W = K(W, v);
          V = K(V, g);
        }
        var i = B(Y) + B(X) + B(W) + B(V);
        return i.toLowerCase();
      };
      return 'https://www.gravatar.com/avatar/' + MD5(email) + '.jpg?s=' + this.state.size + "&d=404";
    }
  }, {
    key: "setSize",
    value: function setSize() {
      var size = 64;
      switch (this.props.size) {
        case "xLarge":
          size = 96;
          break;
        case "large":
          size = 64;
          break;
        case "medium":
          size = 48;
          break;
        case "small":
          size = 32;
          break;
        case "xsmall":
          size = 24;
          break;
      }
      return size;
    }
  }, {
    key: "render",
    value: function render() {
      var fullName = this.props.fullName !== null ? this.props.fullName.split(' ') : "";
      var initial = "";
      var classes = (0, _classnames["default"])("avatar-component", this.props.className);
      for (var i = 0; i < fullName.length; i++) {
        initial += fullName[i].substring(0, 1);
        if (i === 1) break;
      }
      var img;
      if (this.state.display && !this.props.forceText) {
        img = /*#__PURE__*/_react["default"].createElement("img", {
          ref: this.avatarRef,
          src: this.get_avatar(),
          width: this.state.size,
          height: this.state.size,
          style: {
            display: this.state.display ? "initial" : "none"
          }
        });
      } else {
        if (initial === "") {
          img = /*#__PURE__*/_react["default"].createElement("div", {
            className: this.props.size
          }, this.props.email[0]);
        } else {
          img = /*#__PURE__*/_react["default"].createElement("div", {
            className: this.props.size
          }, initial);
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: {
          width: this.state.size + "px",
          height: this.state.size + "px"
        }
      }, img);
    }
  }]);
}(_react.Component);
;
Avatar.propTypes = {
  forceText: _propTypes["default"].bool,
  email: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(["xLarge", "large", "medium", "small", "xsmall"]),
  fullName: _propTypes["default"].string
};
Avatar.defaultProps = {
  forceText: false,
  email: null,
  size: "medium",
  fullName: null
};
var _default = exports["default"] = Avatar;